{
  "name": "simple-savings-guide",
  "type": "module",
  "version": "3.3.5-109-name-changes-a22.1",
  "scripts": {
    "watch": "ng test",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "ng": "ng",
    "start": "cp ./package.json ./src/assets && ng serve --ssl --host localhost-internal.sparbanken.me",
    "style-lint": "stylelint  src/**/*.scss --fix",
    "test": "ng test --watch=false --coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.2",
    "@angular/common": "^22.1.3",
    "@angular/compiler": "^22.1.2",
    "@angular/core": "^22.1.3",
    "@angular/forms": "^22.1.2",
    "@angular/platform-browser": "^22.1.2",
    "@angular/platform-browser-dynamic": "^22.1.2",
    "@angular/router": "^22.1.2",
    "@eslint/js": "^10.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/core": "^22.1.4",
    "@angular-devkit/schematics": "^22.1.4",
    "@angular/build": "^22.1.4",
    "@angular/cdk": "^22.1.2",
    "@angular/cli": "^22.1.2",
    "@angular/compiler-cli": "^22.1.2",
    "@angular/material": "^22.1.2",
    "@sparbanken-syd/abasec": "^4.2.1",
    "@sparbanken-syd/auth-backend": "^2.6.5",
    "@sparbanken-syd/document-service": "2.3.2",
    "@sparbanken-syd/personnummer": "^3.1.0",
    "@sparbanken-syd/simple-savings-guide-be": "^3.4.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.2",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.0.2",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@sparbanken-syd/teradata-user": "^3.5.2",
    "@types/node": "^24",
    "@types/sinon": "^21.0.1",
    "@vitest/coverage-v8": "^4.1.11",
    "angular-eslint": "^22.1.0",
    "baseline-browser-mapping": "2.11.19",
    "eslint": "^10.9.1",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.0.1",
    "ngx-extended-pdf-viewer": "^29.0.1",
    "postcss": "^8.5.14",
    "stylelint": "^17.14.1",
    "stylelint-config-sass-guidelines": "^13.0.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.1.0",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.59.2",
    "vitest": "^4.0.8"
  }
}
